import type { VoidFunctionComponent } from 'react';

/**
 * Details tab for the SnippetDrawer.
 * Displays more details about a given snippet.
 */
const SnippetsDrawerDetails: VoidFunctionComponent = () => {
  return (
    <div>
      Details about your snippet dropping soon! <a href="https://fossa.atlassian.net/browse/CORE-5420" target="_blank" rel="noreferrer">(CORE-5420)</a>
    </div>
  );
};

export default SnippetsDrawerDetails;
